// src/firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyD6d2uvXshy4aaE1_Pld98CewhmMxBe1Fg",
  authDomain: "pesach-snek.firebaseapp.com",
  databaseURL: "https://pesach-snek-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "pesach-snek",
  storageBucket: "pesach-snek.firebasestorage.app",
  messagingSenderId: "974137651830",
  appId: "1:974137651830:web:30a6633ff53af1a8afe557"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
